var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderfloorHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.0852H22M2 19.1429H22M2 22H22M4.98795 14.2306C4.98795 12.8271 5.95181 12.6266 5.95181 11.6241C5.95181 10.6216 4.98795 10.1203 4.98795 9.26817C4.98795 8.41604 5.95181 8.06516 5.95181 7.31328C5.95181 6.5614 4.98795 6.1604 4.98795 5.15789C4.98795 4.15539 5.42169 2 5.42169 2M5.42169 2L3.3012 4.20551M5.42169 2L7.39759 4.20551M18.0964 14.2306C18.0964 12.8271 19.0602 12.6266 19.0602 11.6241C19.0602 10.6216 18.0964 10.1203 18.0964 9.26817C18.0964 8.41604 19.0602 8.06516 19.0602 7.31328C19.0602 6.5614 18.0964 6.1604 18.0964 5.15789C18.0964 4.15539 18.5301 2 18.5301 2M18.5301 2L16.4096 4.20551M18.5301 2L20.506 4.20551M11.494 14.2306C11.494 12.8271 12.4578 12.6266 12.4578 11.6241C12.4578 10.6216 11.494 10.1203 11.494 9.26817C11.494 8.41604 12.4578 8.06516 12.4578 7.31328C12.4578 6.5614 11.494 6.1604 11.494 5.15789C11.494 4.15539 11.9277 2 11.9277 2M11.9277 2L9.80723 4.20551M11.9277 2L13.9036 4.20551",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderfloorHeating);
export default __webpack_public_path__ + "static/media/underfloor_heating.602a3e1acade2776afa56b659293c950.svg";
export { ForwardRef as ReactComponent };